<!--
	作者：Shujuan Sun
	时间：2017-04-21
	描述：监控平台页面-底部关注面板组件
-->
<template>
	<div class="tab-barB">
		<div class="location_title location_title_line">
			<div class="location_number">
                <dl>
	                <dt @click="refreshFollow"><a>刷新</a></dt>
	                <dd>
	                	<span @click="showAll" :class="{active:showType===0}" class="sp_line">总数：<a>{{itemObj.total}}辆 </a></span>
	                	<span @click="onlineOnly" :class="{active:showType===1}" class="sp_line">在线：<a>{{itemObj.online}}辆</a></span>
	                	<span @click="offlineOnly" :class="{active:showType===2}">离线：<a>{{itemObj.offline}}辆</a></span>
	                	<span @click="runOnly" :class="{active:showType===3}" class="sp_line">行驶中：<a>{{itemObj.running}}辆</a></span>
	                	<span @click="stopOnly" :class="{active:showType===4}">停车中：<a>{{itemObj.parking}}辆</a></span>
	                	<span @click="unknownOnly" :class="{active:showType===5}">未知：<a>{{itemObj.unknown}}辆</a></span>
	                </dd>
              </dl>
			</div>
			<div class="location_btn">
			    <dl>
			        <dt><span>筛选：{{showStatus}}<a @click="showAll">取消筛选</a></span></dt>
			        <dd>
			        	<span>批量处理：</span>
			        	<span @click="traceAll" :class="{active:operateType===0}"><a class="ico07">跟踪</a></span>
			            <span @click="locateAll" :class="{active:operateType===1}"><a class="ico01">定位</a></span>
			            <span v-if="permission.indexOf('monitorVehicle_trace') == -1" @click="trackAll" :class="{active:operateType===3}"><a class="ico03">轨迹</a></span>
			            <span @click="removeAll" :class="{active:operateType===4}"><a class="ico04">移出</a></span>	            
			            <span @click="outputAll" :class="{active:operateType===6}"><a class="ico06">导出</a></span>
			         </dd>
			    </dl>
			</div>
		</div>
		<div class="tab-rowB">
			<div class="location_table">
				<table class="table mb0px table-striped table-bordered">
					<thead>
						<tr>
							<th></th>
							<th>车牌号</th>
							<th>服务号</th>
							<th>服务截至</th>
							<th>主设备状态</th>
							<th>活动（定位）时间</th>
							<th>服务器时间</th>
							<th>初次定位时间</th>
							<th>时速</th>
							<th>方向</th>
							<th>当前地区</th>
							<th>日里程</th>
							<th>月里程</th>
							<th>总里程</th>
							<th>ACC状态</th>
							<th class="ellip">地址详情</th>
							<th>机构详情</th>
							<th>刷新时间</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<tr class="list-complete-item" style="-moz-user-select:none;-ms-user-select:none;-webkit-user-select:none;" v-for="(listItem,index) in infoArr" :key="listItem.vehicleId" @click="locating(listItem.deviceId)" @dblclick="goFile(listItem.plateNumber,listItem.vehicleId)">
							<td class="hand" @click.stop="stopFollowing(listItem.vehicleId,index)">取消关注</td>
							<td>{{listItem.plateNumber}}</td>
							<td>{{listItem.vehicleAccount}}</td>
							<td>{{listItem.serviceEndTimeStr}}</td>
							<td class="hand"> 	
								<span>{{listItem.wifiFlagStr}}</span> | 
								<span v-if="listItem.wifiFlagStr==='无线'" :class="{red:listItem.wifiFlagStr==='无线' && listItem.power < 20}"><img src="../../../assets/project/images/map/map_icon_c0.png"/>{{listItem.power}}%</span>
								<span v-if="listItem.wifiFlagStr==='无线'"> |</span>
								<span class="tip" data-toggle="seltip" data-placement="top" :title="switchLocMode(listItem.locModeStr)" :tip="switchLocMode(listItem.locModeStr)">{{listItem.locModeStr}}</span> | 
								<span class="tip" data-toggle="seltip" data-placement="top" :title="listItem.momentTime" :tip="listItem.momentTime">{{listItem.status}}</span>
								<span class="tip" data-toggle="seltip" data-placement="top" :title="listItem.deviceTotalContent" :tip="listItem.deviceTotalContent" @click.stop="showStatusList(listItem.vehicleId,listItem.plateNumber,listItem.vehicleAccount)"><img src="../../../assets/project/images/map/map_icon_93.png"/></span>
							</td>
							<td class="hand">
								<span class="tip" data-toggle="seltip" data-placement="top" :title="'活动时间：' + listItem.receiveTime" :tip="'活动时间：' + listItem.receiveTime">{{listItem.receiveTimeStr}}</span>
								<span class="tip" data-toggle="seltip" data-placement="top" :title="'定位时间：' + listItem.gpsTime" :tip="'定位时间：' + listItem.gpsTime">{{listItem.gpsTimeStr}}</span>
							</td>
							<td>{{listItem.receiveTime}}</td>
							<td>{{listItem.activeTimeStr}}</td>
							<td>{{listItem.speed}}km</td>
							<td class="hand t_center tip" data-toggle="seltip" data-placement="right" :title="listItem.directionName" :tip="listItem.directionName"><span class="fa" :class="switchStrToArr(listItem.directionName)"></span></td>
							<td>{{listItem.city}}</td>
							<td>{{listItem.todayMileageKm}}km</td>
							<td>{{listItem.monthMileageKm}}km</td>
							<td>{{listItem.totalMileageKm}}km</td>
							<td>{{vehicleStatus(listItem.accStop)}}</td>
							<td data-toggle="seltip" data-placement="top" :title="listItem.address" :tip="listItem.address" class="hand tip"><div class="ellip">{{listItem.address}}</div></td>
							<td>{{listItem.path}}</td>
							<td>{{listItem.updateTimeStr}}</td>
							<td>
								<a @click.stop="track(listItem.vehicleId)">跟踪</a>
								<!--<a @click.stop="refresh(listItem.vehicleId,index)">刷新</a>-->
								<a @click.stop="locating(listItem.deviceId)">定位</a>
								<a v-if="permission.indexOf('monitorVehicle_carListDetail') == -1" @click.stop="addTab(listItem.plateNumber,listItem.vehicleId)">档案</a>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<!--分页组件开始-->
			<pagination v-on:getData="getPageNo" v-if="infoArr.length!=0" :pageInfo="pageInfos"></pagination>
			<!--分页组件结束-->
		</div>
	</div>
</template>
<script>
	import {mapState} from 'vuex'
	import Pagination from 'components/common/Pagination'
	import {bottomTabMixin,goTabMixin} from 'util/util.js'
	export default{
		name:'VehicleFollow',
		mixins:[bottomTabMixin,goTabMixin],
		data(){
			return {
				permission:this.$store.state.permission.permission["monitorVehicle"]?this.$store.state.permission.permission["monitorVehicle"]:[],		
				infoArr:[],
				itemObj:{
					offline:0,
					online:0,
					parking:0,
					running:0,
					unknown:0,
					total:0
				},	//顶部对象
				pageInfos:{
					pageNum: 0,
					pages: 1,
					total:0,
					isFirstPage: false,
					isLastPage: false
				},
				showStatus:'全部',
				showType:0,
				operateType:'',
				clickTimer:null,
				pageNo:1
			}
		},
		components:{
			Pagination
		},
		props:['followObj'],
		computed:{
			...mapState({
				curIndex:state=>state.monitor.curIndex,
				tabFollowList:state=>state.monitor.tabFollowList,
				deviceListComp:state=>state.monitor.deviceListComp,
				vehicleDInfo:state=>state.monitor.vehicleDInfo
			})
		},
		watch:{
			followObj:{
				handler:function(val){
					$('.tip').attr('data-original-title','')
					this.$emit('updateTip') 
					if(val==null){
						this.infoArr = []
						this.itemObj = {
							offline:0,
							online:0,
							parking:0,
							running:0,
							unknown:0,
							total:0
						}
						this.pageInfos={
									pageNum: 0,
									pages: 1,
									total:0,
									isFirstPage: false,
									isLastPage: false
								}
					}else{
						this.itemObj = val
						this.infoArr = val.vehicleMonitorList.list
						const {pageNum,pages,total,isFirstPage,isLastPage} = val.vehicleMonitorList
						this.pageInfos = {
								pageNum: pageNum,
								pages: pages,
								total:total,
								isFirstPage: isFirstPage,
								isLastPage: isLastPage
							}
					}
				},
				deep:true
			},
			curIndex:function(val){
				if(val!=0){
					const index = this.tabFollowList.findIndex(n=>n.id==val)
					if(this.tabFollowList[index].vehicleMonitorStatistics==null){
						this.itemObj = {
							offline:0,
							online:0,
							parking:0,
							running:0,
							unknown:0,
							total:0
						}
						this.pageInfos = {
							pageNum: 0,
							pages: 1,
							total:0,
							isFirstPage: false,
							isLastPage: false
						}
					}else{
						this.itemObj = this.tabFollowList[index].vehicleMonitorStatistics
						this.pageInfos = {
							pageNum:this.itemObj.vehicleMonitorList.pageNum,
							pages: this.itemObj.vehicleMonitorList.pages,
							total: this.itemObj.vehicleMonitorList.total,
							isFirstPage:this.itemObj.vehicleMonitorList.isFirstPage,
							isLastPage:this.itemObj.vehicleMonitorList.isLastPage
						}
					}
				}
			}
		},
		mounted(){
			if(this.followObj == null){
				this.itemObj = {
					offline:0,
					online:0,
					parking:0,
					running:0,
					unknown:0,
					total:0
				}
				this.pageInfos={
						pageNum: 0,
						pages: 1,
						total:0,
						isFirstPage: false,
						isLastPage: false
					}
			}else{
				this.itemObj = this.followObj
				const {pageNum,pages,total,isFirstPage,isLastPage} = this.followObj.vehicleMonitorList
				this.pageInfos = {
					pageNum: pageNum,
					pages: pages,
					total:total,
					isFirstPage: isFirstPage,
					isLastPage: isLastPage
				}
			}
			this.infoArr = this.followObj === null? []: this.followObj.vehicleMonitorList.list
			$(function () {//启用tooltip
			  $('[data-toggle="seltip"]').tooltip({
			  	container:'body'
			  })
			   $('.list-complete-item').bind('selectstart',function(){
			  	return false
			  })
			})
		},
		updated(){
			this.$emit('updateTip') 
		},
		destroyed(){
			$('[data-toggle="seltip"]').tooltip('hide')
		},
		methods:{
			// showNum(item){
			// 	let tempArr = [
			// 		'BK200','DC5C','DC5C-8','Acar','DG02','DG02B','GT520','DO500','DC740','DC750',
			// 		'DGV25','DGM02','Golo2'
			// 	]
			// 	if(tempArr.includes(item.deviceType)){
			// 		return true
			// 	}
			// 	return false
			// },
			getPageNo(pageNo){//分页
				if(this.curIndex!=0){
					const followParam = {//初始化关注面板参数
						tagpanelId:this.curIndex,
						obj:{
							searchType:0,
							page_index:pageNo,
							sort_asc:'',
							sort_desc:''
						}
					}
					this.$store.dispatch('getFollowPanel',followParam)
					this.pageNo = pageNo
				}
			},
			stopFollowing(id,carIndex){//点击取消关注-取消单个车辆
				const param = {
					tagpanelId:this.curIndex,
					vehicleId:id
				}
				this.$store.dispatch('loadingCarTab',true)
				this.$http.delete(process.env.API_ROOT + '/monitor/tagpanel/vehicle',{params:param})
				.then((response) => {
					this.$store.dispatch('loadingCarTab',false)
					if(response.body.success){
						this.refreshFollow()
					}else{
						this.$store.dispatch('tipModalShow',response.body.message)
					}
				},(response)=>{
					this.$store.dispatch('loadingCarTab',false)
					this.$store.dispatch('tipModalShow',response.body.message)
				})
				.catch((response)=>{
					this.$store.dispatch('loadingCarTab',false)
					this.$store.dispatch('tipModalShow',OPERATE_EXCEPTION)
				})
			},
			track(id){//添加到跟踪画面
				const obj = {//点开到跟踪标签
						name:'车辆跟踪视窗',
						id:'PageCarRail',
						route:'/indexhome/carRail',
						No:'carRail'
				}
				this.$router.push(obj.route);
				this.$store.dispatch('addTab',obj);
				this.$http.post(process.env.API_ROOT + '/monitor/track/tracks?vehicleId=' + id)
					.then((res)=>{
						this.$store.dispatch('getTrackMap')
					},(res)=>{
						this.$store.dispatch('showRailModal',res.body.message)
					})
					.catch((res)=>{
						this.$store.dispatch('showRailModal','请求异常')
					})
			},
			refresh(id,index){//只刷新当前行
				this.$store.dispatch('loadingCarTab',true)
				this.$http.get(process.env.API_ROOT + '/monitor/tagpanel/'+ this.curIndex + '/' + id)
				.then((response) => {
					this.$store.dispatch('loadingCarTab',false)
					if(response.body.success){
						let obj = response.body.data
						this.infoArr[index] = obj.vehicleMonitorList.list[0]
						this.infoArr.splice(index,1,this.infoArr[index])
					}else{
						this.$store.dispatch('tipModalShow',OPERATE_EXCEPTION)
					}
				},(response)=>{
					this.$store.dispatch('loadingCarTab',false)
					this.$store.dispatch('tipModalShow',response.body.message)
				})
				.catch((response)=>{
					this.$store.dispatch('loadingCarTab',false)
					this.$store.dispatch('tipModalShow',OPERATE_EXCEPTION)
				})
			},
			/*
			 以下为关注面板顶部
			 * */
			refreshFollow(){//批量刷新
				this.showType = 0
				this.showStatus = '全部'
				const followObj = {
						tagpanelId:this.curIndex,
						obj:{
							searchType:0,
							page_index:this.pageNo,
							sort_asc:'',
							sort_desc:''
						}
				}
				this.$store.dispatch('refreshFollowPanel',followObj)
			},
			onlineOnly(){//筛选--仅在线
				this.showStatus = '在线'
				this.showType = 1
				const followObj = {
						tagpanelId:this.curIndex,
						obj:{
							searchType:1,
							page_index:1,
							sort_asc:'',
							sort_desc:''
						}
					}
				this.$store.dispatch('getFollowPanel',followObj)
				
			},
			offlineOnly(){//筛选--仅离线
				this.showStatus = '离线'
				this.showType = 2
				const followObj = {
						tagpanelId:this.curIndex,
						obj:{
							searchType:2,
							page_index:1,
							sort_asc:'',
							sort_desc:''
						}
					}
				this.$store.dispatch('getFollowPanel',followObj)
			},
			runOnly(){//筛选--仅行驶
				this.showStatus = '行驶'
				this.showType = 3
				const followObj = {
						tagpanelId:this.curIndex,
						obj:{
							searchType:3,
							page_index:1,
							sort_asc:'',
							sort_desc:''
						}
					}
				this.$store.dispatch('getFollowPanel',followObj)
			},
			stopOnly(){//筛选--仅停车
				this.showStatus = '停车'
				this.showType = 4
				const followObj = {
						tagpanelId:this.curIndex,
						obj:{
							searchType:4,
							page_index:1,
							sort_asc:'',
							sort_desc:''
						}
					}
				this.$store.dispatch('getFollowPanel',followObj)
			},
			unknownOnly(){//筛选--未知
				this.showStatus = '未知'
				this.showType = 5
				const followObj = {
						tagpanelId:this.curIndex,
						obj:{
							searchType:5,
							page_index:1,
							sort_asc:'',
							sort_desc:''
						}
					}
				this.$store.dispatch('getFollowPanel',followObj)
			},
			showAll(){//取消筛选
				this.showType=0;
				this.showStatus="全部"
				const followObj = {
						tagpanelId:this.curIndex,
						obj:{
							searchType:0,
							page_index:1,
							sort_asc:'',
							sort_desc:''
						}
					}
				this.$store.dispatch('getFollowPanel',followObj) 
			}, 
			locateAll(){//批量定位
				this.operateType = 1
				const param = {
					tagpanelId:this.curIndex
				}
				this.$store.dispatch('locateAll',param)
				
			},
			trackAll(){//批量定位--追加队列
				//1,切换到轨迹回放tab
				this.openDidiVehicleTrace()
				// const obj = {
				// 	name:'车辆轨迹回放',
				// 	code:'vehicleTrace',
				// 	id:'PageVehicleTrace',
				// 	route:'/indexhome/vehicleTrace',
				// 	No:'vehicleTrace'
				// }
				// this.$router.push(obj.route);
				// this.$store.dispatch('addTab',obj);
				const param = {
					tagpanelId: this.curIndex
				}
				this.$store.dispatch('trackAll', param).then(()=>{
					this.$store.dispatch('getTraces',1)
				})
				this.operateType = 3
			},
			removeAll(){//批量移出
				this.operateType = 4
				this.delFollowList()
			},
			delFollowList(){//清空关注面板
				this.$store.dispatch('loadingCarTab',true)
				const param = {
					tagpanelId:this.curIndex
				}
				this.$http.delete(process.env.API_ROOT + '/monitor/tagpanel/vehicle',{params:param})
				.then((response) => {
					this.$store.dispatch('loadingCarTab',false)
					if(response.body.success){
						this.itemObj = {
							offline:0,
							online:0,
							parking:0,
							running:0,
							unknown:0,
							total:0
						}
						this.pageInfos = {
							pageNum: 0,
							pages: 1,
							total:0,
							isFirstPage: false,
							isLastPage: false
						}
						this.$store.dispatch('getAllFollow')//初始化用户关注面板信息
					}else{
						this.$store.dispatch('tipModalShow',response.body.message)
					}
				},(response)=>{
					this.$store.dispatch('loadingCarTab',false)
					this.$store.dispatch('tipModalShow',response.body.message)
				})
				.catch((response)=>{
					this.$store.dispatch('loadingCarTab',false)
					this.$store.dispatch('tipModalShow',OPERATE_EXCEPTION)
				})
			},
			vehicleStatus(status){
				if(status == 0){
					return "熄火"
				}
				if(status == 1){
					return "点火"
				}
				if(status == 2){
					return "未知"
				}
			},
			outputAll(){//批量导出
				this.operateType = 6
				const followObj = {
						tagpanelId:this.curIndex, 
						searchType:0,
						page_index:1,
						sort_asc:'',
						sort_desc:'' 
					}
				this.$store.dispatch('loadingCarTab',true)	
				this.$http.get(process.env.API_ROOT + '/monitor/tagpanel/vehicles/export',{params:followObj})
					.then((res)=>{
						let str = res.body.data
						var path = process.env.EXPORT_PATH;
						var api = process.env.API_ROOT;
						var fileName = path  + api + '/noauth/export?url=' + str  + '&path=' + this.$store.state.user.userId;
	    				var elemIF = document.createElement("iframe");   
			            elemIF.src = fileName;   
			            elemIF.style.display = "none";   
			            document.body.appendChild(elemIF); 
			            this.$store.dispatch('loadingCarTab',false)
					},(res)=>{
						this.$store.dispatch('loadingCarTab',false)
						this.$store.dispatch('tipModalShow',res.body.message)
					})
					.catch((res)=>{
						this.$store.dispatch('loadingCarTab',false)
						this.$store.dispatch('tipModalShow',EXPORT_EXCEPTION)
					})
			}
		}
	}
</script>
<style>
	
</style>


// WEBPACK FOOTER //
// VehicleFollow.vue?7bedafdc